// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","943":"partners"}[chunkId] + "." + {"443":"a7ea4713","943":"2dd37cd3"}[chunkId] + ".js";
};